var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33204 24.5546L3.30621 24.5804C2.95746 23.8183 2.73788 22.9529 2.64746 21.9971C2.73788 22.94 2.98329 23.7925 3.33204 24.5546Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6249 13.4074C13.3228 13.4074 14.6991 12.031 14.6991 10.3332C14.6991 8.63538 13.3228 7.25903 11.6249 7.25903C9.92713 7.25903 8.55078 8.63538 8.55078 10.3332C8.55078 12.031 9.92713 13.4074 11.6249 13.4074Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9118 2.58325H10.0876C5.38592 2.58325 2.58301 5.38617 2.58301 10.0878V20.912C2.58301 22.3199 2.82842 23.547 3.30634 24.5803C4.41717 27.0345 6.79384 28.4166 10.0876 28.4166H20.9118C25.6134 28.4166 28.4163 25.6137 28.4163 20.912V17.9541V10.0878C28.4163 5.38617 25.6134 2.58325 20.9118 2.58325ZM26.3109 16.1458C25.3034 15.2803 23.6759 15.2803 22.6684 16.1458L17.2951 20.757C16.2876 21.6224 14.6601 21.6224 13.6526 20.757L13.2134 20.3953C12.2963 19.5945 10.8368 19.517 9.80343 20.2145L4.97259 23.4566C4.68842 22.7333 4.52051 21.8937 4.52051 20.912V10.0878C4.52051 6.44534 6.44509 4.52075 10.0876 4.52075H20.9118C24.5543 4.52075 26.4788 6.44534 26.4788 10.0878V16.2878L26.3109 16.1458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.d24896c2860a4d01ba76f1f849d8d80e.svg";
export { ForwardRef as ReactComponent };